export default __webpack_public_path__ + "1.19.2/static/media/LibreDataSharecode_Japanese.30f658c9.svg";